<template>
  <p-modal
    name="credit-card-info-modal"
    :width="796"
    @closed="onModalClosed"
  >
    <div class="credit-card-info">
      <h1 class="card-info-title mb-4">
        Card Info
      </h1>

      <form @submit.prevent="onFormSubmitted">
        <text-field
          id="name-on-card"
          v-model="formData.name_on_card"
          label="Name On Card:"
          label-class="label-form mb-2"
          class="mb-4"
        />

        <text-field
          id="billing-address"
          v-model="formData.billing_address"
          label="Billing Address:"
          label-class="label-form mb-2"
          class="mb-4"
        />

        <div class="row mb-4">
          <div class="col-8">
            <text-field
              id="billing-city"
              v-model="formData.billing_city"
              label="Billing City:"
              label-class="label-form mb-2"
            />
          </div>

          <div class="col-2">
            <text-field
              id="billing-state"
              v-model="formData.billing_state"
              label="Billing State:"
              label-class="label-form mb-2"
            />
          </div>

          <div class="col-2">
            <text-field
              id="billing-zip"
              v-model="formData.billing_zip"
              label="Billing Zip:"
              label-class="label-form mb-2"
            />
          </div>
        </div>

        <div class="exp mb-4">
          <label
            for=""
            class="label-form mb-2"
          >Exp Date</label>
          <div
            class="d-flex align-items-center mb-4"
            style="gap: 10px"
          >
            <text-field
              id="month-exp-date"
              v-model="formData.month_exp_date"
              label-class="label-form mb-2"
              style="width: 15%"
            />

            <div>–</div>

            <text-field
              id="year-exp-date"
              v-model="formData.year_exp_date"
              label-class="label-form mb-2"
              style="width: 15%"
            />
          </div>
        </div>

        <div class="cvv mb-4">
          <label
            for=""
            class="label-form mb-2"
          >CVV</label>
          <div
            class="d-flex align-items-center mb-4"
            style="gap: 10px"
          >
            <text-field
              id="cvv"
              v-model="formData.cvv"
              label-class="label-form mb-2"
              style="width: 15%"
            />
          </div>
        </div>

        <div class="d-flex align-items-center">
          <fa
            icon="trash-alt"
            style="font-size: 43px"
            class="cursor-pointer"
            @click="deleteCard"
          />
          <div class="w-100 d-flex justify-content-center">
            <p-button
              style="padding: 20px 70px"
              class="text-capitalize"
            >
              {{ formLoading ? 'Saving...' : 'Save' }}
            </p-button>
          </div>
        </div>
      </form>
    </div>
  </p-modal>
</template>

<script>
import PModal from '~/components/core/PModal'
import TextField from '~/components/core/Inputs/TextField'
import PButton from '~/components/core/PButton'
import { mapActions } from 'vuex'

export default {
  name: 'CardInfoModal',
  components: { PButton, TextField, PModal },
  props: {
    cardData: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    formData: {
      name_on_card: '',
      billing_address: '',
      billing_city: '',
      billing_state: '',
      billing_zip: '',
      month_exp_date: '',
      year_exp_date: '',
      cvv: ''
    },
    formLoading: false
  }),
  watch: {
    cardData (val) {
      if (val) {
        this.formData = {
          name_on_card: val?.name_on_card,
          billing_address: val?.billing_address,
          billing_city: val?.billing_city,
          billing_state: val?.billing_state,
          billing_zip: val?.billing_zip,
          month_exp_date: val?.month_exp_date,
          year_exp_date: val?.year_exp_date,
          cvv: val?.cvv
        }

        return
      }

      this.formData = this.formDataObj()
    }
  },
  methods: {
    ...mapActions({
      updateCardInfo: 'checkout/updateCardInfo',
      deleteCardInfo: 'checkout/deleteCardInfo',
      fetchUser: 'auth/fetchUser'
    }),
    async onFormSubmitted () {
      this.formLoading = true
      const payload = {
        id: this.cardData.id,
        data: this.formData
      }
      await this.updateCardInfo(payload)
      // await this.fetchUser()
      this.formLoading = false
      this.$emit('cardUpdated')
      this.closeModal()
    },
    closeModal () {
      this.$modal.hide('credit-card-info-modal')
    },
    onModalClosed () {
      // this.formData = this.formDataObj()
      this.$emit('modalClosed')
    },
    async deleteCard () {
      await this.deleteCardInfo(this.cardData.id)
      // await this.fetchUser()
      this.$emit('cardDeleted')
      this.closeModal()
    },
    formDataObj () {
      return {
        name_on_card: '',
        billing_address: '',
        billing_city: '',
        billing_state: '',
        billing_zip: '',
        month_exp_date: '',
        year_exp_date: '',
        cvv: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.credit-card-info {
    padding: 30px;

    .card-info-title {
        font: normal normal bold 16px/18px Arial;
        color: #383838;
    }

    form {
        ::v-deep {
            .label-form {
                font: normal normal normal 14px/16px Arial;
                color: #000000;
            }
        }

    }
}
</style>
